import React, {useEffect, useState} from 'react';
import './Dashboard.css';
import IconButton from '@mui/material/IconButton'
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {strings} from "../../../strings";
import failStatus from "../../utils/failStatus";
import {selToken} from "../../../stores/base/baseSlice";
import { trackPromise } from 'react-promise-tracker';
import {notification} from "../../functions/notification/notificationFunction";
import RESETAPP from "../../utils/resetApp";
import {CounterChart} from "../../module";
import separate from "../../functions/separate/separate";

function Dashboard() {

    const dispatch = useDispatch();
    let token = useSelector(selToken)
    const [data, setData] = useState([]);

    useEffect(()=>{
        // Promise.all([
        //     fetch('https://jsonplaceholder.typicode.com/posts'),
        //     fetch('https://jsonplaceholder.typicode.com/users')
        // ]).then(function (responses) {
        //     // Get a JSON object from each of the responses
        //     return Promise.all(responses.map(function (response) {
        //         return response.json();
        //     }));
        // }).then(function (data) {
        //     // Log the data to the console
        //     // You would do something with both sets of data here
        //     console.log(data);
        // }).catch(function (error) {
        //     // if there's an error, log it
        //     console.log(error);
        // });
        if(token !== ""){
            Promise.all([
                trackPromise(axios.get(strings.baseUrl+`admin/dashboard/user`,{headers:{
                        'Authorization': token
                    }},)),
                axios.get(strings.baseUrl+`admin/dashboard/licence`,{headers:{
                        'Authorization': token
                    }},),
                axios.get(strings.baseUrl+`admin/dashboard/order`,{headers:{
                        'Authorization': token
                    }},),
                axios.post(strings.baseUrl+`admin/dashboard/topin`,{},{headers:{
                        'Authorization': token
                    }},)
            ]).then(function (responses) {
                // Get a JSON object from each of the responses
                return Promise.all(responses.map(function (response,reject) {
                    if (failStatus(response.data, dispatch)) return "" ;
                    return response.data.data
                }));
            }).then(function (dataAll) {
                // Log the data to the console
                // You would do something with both sets of data here
                setData(dataAll)
            }).catch(function (error) {
                // if there's an error, log it
                console.log(error);
            });
        }
    },[])

    return (
        <div className="d-flex flex-column w-100">
            <div className="parentDashboardPage">
                <div className="boxDetailDashboard green">
                    <IconButton>
                        <i className="fab fa-first-order"/>
                    </IconButton>
                    <div className="d-flex flex-column align-items-center">
                        <span>
                             موجودی تاپین : {data[3] ?  separate(data[3]?.topin_credit) : ''}
                        </span>
                        {/*<span>*/}
                        {/*     فروش امروز : 30*/}
                        {/*</span>*/}
                    </div>
                </div>
                <div className="boxDetailDashboard blue">
                    <IconButton>
                        <i className="fas fa-user-alt"/>
                    </IconButton>
                    <div className="d-flex flex-column align-items-center">
                    <span>
                        کاربران ثبت شده : {data &&  data[0]?.total_users}
                    </span>
                        <span>
                        ثبت شده امروز : {data &&  data[0]?.new_users}
                    </span>
                    </div>
                </div>
                <div className="boxDetailDashboard yellow">
                    <IconButton>
                        <i className="fas fa-donate"/>
                    </IconButton>
                    <div className="d-flex flex-column align-items-center">
                    <span>
                         کل سفارشات : {data &&  data[2]?.total_successful_order}
                    </span>
                        <span>
                         سفارشات معلق : {data &&  data[2]?.total_pending_orders}
                    </span>
                        <span>
                         سفارشات امروز : {data &&  data[2]?.today_successful_order}
                    </span>
                        <span>
                         آخرین سفارش : {data &&  data[2]?.last_order_time?.replaceAll("-","/")}
                    </span>
                    </div>
                </div>
                <div className="boxDetailDashboard red">
                    <IconButton>
                        <i className="fas fa-star-of-life"/>
                    </IconButton>
                    <div className="d-flex flex-column align-items-center">
                    <span>
                         تعداد کل لایسنس ها : {data &&  data[1]?.total_licences}
                    </span>
                        <span>
                         لایسنس های فروخته شده : {data &&  data[1]?.total_sold_licences}
                    </span>
                        <span>
                         لایسنس های فعال : {data &&  data[1]?.total_active_licences}
                    </span>
                    </div>
                </div>
                {/*<div className="boxDetailDashboard pink">*/}
                {/*    <IconButton>*/}
                {/*        <i className="fas fa-calendar-alt"/>*/}
                {/*    </IconButton>*/}
                {/*    <div className="d-flex flex-column align-items-center">*/}
                {/*        <span>*/}
                {/*             آخرین سفارش : {data &&  data[2]?.last_order_time?.replaceAll("-","/")}*/}
                {/*        </span>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <div>
                <CounterChart data={data}/>
            </div>
        </div>
    );

}

export default Dashboard;